import { TableConfig } from '@shared/interfaces/table/table-config';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { physicalStatusPartial } from '@shared/partials/physicalstatus.partial';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';
import { ConnectionPointMeteringPointDto } from '@app/api/dmc';

export const connectionpointMeteringpointTable: TableConfig<ConnectionPointMeteringPointDto> = {
  columns: [
    {
      title: 'meter.id',
      key: 'meteringPointIdentification',
      width: 175,
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/meteringpoint',
        urlReference: 'meteringPointIdentification',
      }
    },
    {
      title: 'meter.address',
      key: "address",
      width: 300,
    },
    settlementmethodPartial,
    // MeteringPoint Partial
    meteringPointTypePartial,
    physicalStatusPartial,
    {
      title: 'meter.meterid',
      key: 'meterNumber',
    },
    datahubPartial,
  ]
}
